export default "__VITE_PUBLIC_ASSET__cbc84b93__"